import "./App.css";
import Routing from "./Router";
import { useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, Typography } from "@mui/material";
import { IconChevronUp } from "@tabler/icons";
import emitter from "./Common/EventEmitterUtil";
import { config } from "./config";
import { GenerateSRI } from "./Common/SRIUtils";
import AssetLoader from "./Common/AssetLoader";
import { ConsoleError } from "./Common/Logger";
import Banner from "./Components/Banner/banner";
import moment from "moment"


function App() {
  const theme = createTheme({
    palette: {
      common: { black: '#333333' },
      primary: { dark: '#002395', main: '#0065BD', light: '#0088CE' },
      info: { dark: '#002395', main: '#0088CE', light: '#0088CE' },
      secondary: { dark: '#009B74', main: '#00AF3F', light: '#69BE28' },
      error: { dark: '#FF4D4D', main: '#FF4D4D', light: '#FFC96C' },
      warning: { dark: '#FF4D4D', main: '#FF8A00', light: '#FFC96C' },
    },
    typography: {
      fontFamily: "'PTSans', sans-serif",
      //   fontSize: fontsize
      h1: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '46px', lineHeight: '56px', fontWeight: 700, letterSpacing: '0' },
      h2: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '38px', lineHeight: '48px', fontWeight: 700, letterSpacing: '0' },
      h3: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '28px', lineHeight: '38px', fontWeight: 700, letterSpacing: '0' },
      h4: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '20px', lineHeight: '28px', fontWeight: 700, letterSpacing: '0' },
      h5: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '18px', lineHeight: '28px', fontWeight: 700, letterSpacing: '0' },
      h6: { fontFamily: "'PTSans-Bold',  sans-serif", fontSize: '16px', lineHeight: '28px', fontWeight: 700, letterSpacing: '0' },
    }
  });

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const images = [
      `${process.env.PUBLIC_URL}${config?.logoURL}`
    ]; 
    AssetLoader.getInstance().preloadMultipleImages(images)
      .catch((e) => { ConsoleError.error("Failed to load image, ", e);});
  }, []);

  useEffect(() => {
    GenerateSRI(config.wogaaURL);
  }, []);

  useEffect(() => {

    emitter.removeAllListeners();

    emitter.once('duplicateLogin', function (value) {
      alert("Duplicate Login Detected.");
      window.location.replace("/");
    });

    emitter.on('forbidden', function (value) {
      alert("Forbidden");
      window.location.replace("/");
    });

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) setShowButton(true)
      else setShowButton(false);
    });
  }, []);

  const bannerMessage=JSON.parse(config.bannerMessage);
  const bannerStartDate=config.bannerStartDate;
  const bannerEndDate=config.bannerEndDate;
  const scamBannerStartDate = config.scamBannerStartDate;
  const currentDate = moment();
  const isMaintenanceBannerValid = (currentDate > moment(bannerEndDate));
  const scamMessage = [
    { tag: 'b', text: 'Beware of impersonation scams*n' },
    { tag: 'p', text: ''},
    { text: 'Government officials will ' },
    { tag: 'b', text: 'NEVER' },
    { text: ' ask you to transfer money or disclose bank log-in details over a phone call. Call the 24/7 ScamShield Helpline at 1799 if you are unsure if something is a scam. For more information on how to protect yourself against scams, please visit the ' },
    { tag: 'a', defineProps: { href: 'http://www.scamshield.gov.sg' } , text: 'ScamShield website.'}
  ]
  
  return (
    <ThemeProvider theme={theme}>
      <header>
        <sgds-masthead></sgds-masthead>

        <Banner message={scamMessage} startDate={scamBannerStartDate} />
        <div style={{ marginTop: isMaintenanceBannerValid ? '0px' : '10px' }}>
          <Banner message={bannerMessage} startDate={bannerStartDate} endDate={bannerEndDate} />
        </div>
      </header>
      <Routing />
      {showButton && <Button className='back-to-top'
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="back to top">
        <div>
          <IconChevronUp style={{ marginTop: -4 }} />
          <Typography className="font-normal-mine-shaft-14px" textTransform={'none'} mt={-0.7}>
            Top
          </Typography>
        </div>
      </Button>}
    </ThemeProvider>
  );
}

export default App;
